import { render, staticRenderFns } from "./scaleImage.vue?vue&type=template&id=0310bbc1&scoped=true&"
import script from "./scaleImage.vue?vue&type=script&lang=js&"
export * from "./scaleImage.vue?vue&type=script&lang=js&"
import style0 from "./scaleImage.vue?vue&type=style&index=0&id=0310bbc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0310bbc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/liuminming/Documents/zhunduWork/components/photoScanView/photo-scan-view/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0310bbc1')) {
      api.createRecord('0310bbc1', component.options)
    } else {
      api.reload('0310bbc1', component.options)
    }
    module.hot.accept("./scaleImage.vue?vue&type=template&id=0310bbc1&scoped=true&", function () {
      api.rerender('0310bbc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scaleImage.vue"
export default component.exports